module.exports = __webpack_public_path__ + "img/flooz-3.5042fa32.png";